module.exports = __webpack_public_path__ + "static/Firewatch0-e8ec2142fa5e772e7b8fa7620a325694.webp";